module.exports = __webpack_public_path__ + "static/img/14000004.f0a0f275.png";